
export default function ProjectsHero() {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/7ef3bd101ef4caf4467083fe104c0eed.jpg"
          alt="Galería de proyectos robóticos"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center w-full py-32">
        <div className="inline-block mb-6 px-4 py-2 border border-orange-500/50 rounded-full bg-black/30 backdrop-blur-sm">
          <span className="text-orange-400 text-xs md:text-sm font-semibold tracking-widest uppercase">Más de 150 proyectos completados</span>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white mb-6 leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
          Galería de{' '}
          <span className="bg-gradient-to-r from-orange-500 to-green-500 bg-clip-text text-transparent">
            Proyectos
          </span>
        </h1>

        <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-2xl mx-auto">
          Cada proyecto es una solución única diseñada para transformar la producción de nuestros clientes
        </p>
      </div>
    </section>
  );
}
